const fetchJSON = (url, headers) => new Promise((resolve, reject) => {
  window.fetch(url, {
    headers
  }).then((res) => {
    if (!res.ok) return res.json().then((json) => reject(json));
    return resolve(res.json());
  }).catch((err) => reject(err));
});
const asyncFetchJSON = async (url, headers) => {
  const JSON_HEADER = "application/json";
  const CONTENT_TYPE = "content-type";
  let json;
  let status;
  let ok;
  try {
    const res = await window.fetch(url, { headers });
    status = res.status;
    ok = res.ok;
    const contentType = res.headers.get(CONTENT_TYPE);
    const hasJSON = (contentType == null ? void 0 : contentType.includes(JSON_HEADER)) === true;
    if (hasJSON) json = await res.json();
  } catch (error) {
    json = error;
  }
  return {
    json,
    status,
    ok
  };
};
const postJSON = (url, body, headers) => window.fetch(url, {
  method: "POST",
  body: JSON.stringify(body),
  headers: {
    "Content-Type": "application/json",
    ...headers
  },
  credentials: "include"
});
export {
  asyncFetchJSON,
  fetchJSON,
  postJSON
};
//# sourceMappingURL=fetchLib.mjs.map
